import React from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import Shell from "../components/Shell";
import { endpoints } from "../lib/api";
import { useApp } from "../context/AppContext";
import { UBot } from "../components/UBot";

export default function VerifyPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAuth } = useApp();
  const [state, setState] = React.useState("verifying");
  const token = sp.get("token");
  const ran = React.useRef(false);

  React.useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setState("error"); return; }
    endpoints.verify(token).then(async (r) => {
      await refreshAuth();
      toast(`Welcome back! 👋`);
      let me = null;
      try { me = await endpoints.me(); } catch {}
      if (me?.role === "builder") navigate("/builder", { replace: true });
      else if (me?.is_admin) navigate("/admin", { replace: true });
      else navigate("/deck", { replace: true });
    }).catch(() => setState("error"));
  }, [token]); // eslint-disable-line

  return (
    <Shell>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center px-4 py-16 text-center">
        <UBot size={100} />
        {state === "verifying" ? (
          <h1 className="mt-4 font-display text-[24px] font-bold text-white">Signing you in…</h1>
        ) : (
          <div data-testid="verify-expired">
            <h1 className="mt-4 font-display text-[26px] font-extrabold text-white">That link has expired</h1>
            <p className="mt-2 text-on-dark-muted">Let's send a fresh one.</p>
            <Link to="/signin" className="mt-5 inline-block rounded-pill bg-gold-500 px-6 py-3 font-bold text-navy-900">Back to sign in</Link>
          </div>
        )}
      </div>
    </Shell>
  );
}
